import { XCircle } from "lucide-react"
import type { HTMLAttributes } from "react"

import * as styles from "./error-hint.styled"

type ErrorHintProps = HTMLAttributes<HTMLSpanElement>

export const ErrorHint = ({ className, ...props }: ErrorHintProps) => {
  return (
    <div className={styles.root}>
      <XCircle className={styles.icon} />
      <span className={styles.text(className)} {...props} />
    </div>
  )
}
